import {Box, Breadcrumbs, Link, Stack, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import AmenityReservationsPanel from 'src/pages/Amenity/AmenityReservationsPanel';

export default function ReservationsPage() {
  return (
    <Box sx={{px: 3, py: 2, height: '100%', display: 'flex', flexDirection: 'column'}}>
      <Stack spacing={1.5} sx={{mb: 2}}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link component={RouterLink} to="/amenities" underline="hover" color="inherit" variant="body2">
            Amenities
          </Link>
          <Typography color="text.primary" variant="body2">
            Reservations
          </Typography>
        </Breadcrumbs>
        <Typography variant="h6" component="h1">
          All reservations
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Reservations across all amenities for the selected date. Open an amenity to filter by facility.
        </Typography>
      </Stack>

      <Box sx={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column'}}>
        <AmenityReservationsPanel />
      </Box>
    </Box>
  );
}
